export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const PAYMENT_TABS = {
  DOCTORS: "doctors",
  REVENUE: "revenue",
};

export function formatMoney(value) {
  if (value === null || value === undefined) return "—";
  return `${Number(value).toFixed(2)} EGP`;
}

export function formatMonthLabel({ year, month }) {
  return `${MONTH_NAMES[month - 1] || "Unknown"} ${year}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Africa/Cairo",
  });
}
